import React, { useEffect, useState } from 'react'
import Layout from '../Layout/Layout'
import {Form, Spinner} from 'react-bootstrap';
import axios from 'axios';
import PasswordStrengthBar from 'react-password-strength-bar';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
function ResetPassword() {
    const [validated, setValidated] = useState(false);
    const[password, setPassword] = useState('');
    const[cnfpassword, setCnfpassword] = useState('');
    const [errMsg, setErrMsg] = useState({});
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);
    const [formHide, setFormHide] = useState(' form-hide');
    const [passwordMatch, setPasswordMatch] = useState('');
    const [searchParams, setSearchParams] = useSearchParams();
    const prmData = Object.fromEntries([...searchParams]);
    const [token,setToken] = useState(prmData?.token);
    const[validToken, setvalidToken] = useState(true);
    const navigate = useNavigate();
    useEffect(() => {
        if(password!=='' && password.length>=8 && password===cnfpassword){
          setPasswordMatch(' password-matched')
        }else{
          setPasswordMatch('')
        }
      }, [password,cnfpassword]);

      const checkToken = async()=>{
        try {
            let {data} = await axios.post(`${process.env.REACT_APP_API_URL}/auth/reset-password-token`,{token:token});
            //console.log('===>>>',data)
            if(!data.status){
                setFormHide(' form-hide');
                //setErrMsg({cls:'alert alert-warning text-center', msg:'This key is invalid or has already been used. Please reset your password again if needed.'});
                setvalidToken(false);
            }else if(data.status){
                setFormHide('');
            }
        } catch (error) {
            console.log(error)
        }
      }
      useEffect(() => {
        checkToken();
      }, []);
    const handleSubmit = async(event)=>{
        setErrMsg({});
        setLoading(true);
        try {
            //console.log(email)
            event.preventDefault();
            const form = event.currentTarget;
            //console.log(form)
            if (form.checkValidity() === false) {
              event.stopPropagation();
              setLoading(false);
            }    
            setValidated(true);
            if(password.length<8){
                setLoading(false)
                return;
            }
            if(form.checkValidity()===true) {
                const strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
                if(!strongRegex.test(password)) {
                  setLoading(false)
                  setErrMsg({cls:'alert alert-danger text-center', msg:"The password should be at least 8 characters long. To make it stronger, use upper and lower case letters, numbers, and symbols like ! \" ? $ % ^ & )."});
                  return;
                }

                if(password!==cnfpassword){
                    setLoading(false)
                    setErrMsg({cls:'alert alert-danger text-center', msg:"The passwords do not match. Please enter again."});
                    return;
                }
                let {data} = await axios.put(`${process.env.REACT_APP_API_URL}/auth/reset-password`,{token:token,password:password,confirm_password:cnfpassword});
                console.log(data)            
                if(data?.status){
                    //console.log(data?.message)
                    setErrMsg({cls:'alert alert-success text-center', msg:data?.message});                   
                   
                    setFormHide(' form-hide');
                    setSent(true)
                    setLoading(false);
                    setValidated(false)
                    setTimeout(()=>{
                        navigate("/loginwithemail"); 
                      }, 5000);
                }else{
                    //console.log(data?.message)
                    setLoading(false);
                    setErrMsg({cls:'alert alert-danger text-center', msg:data?.message});
                    setFormHide('');
                }
            }
        } catch (error) {
            console.log(error)
        }
    }
    
  return (    
    <Layout title="Reset Password | Chaashni Couture">
        <div className="site-content-wrap login">
            <div className='loginbox'>
                <h2>Reset your password</h2>
                <div className='login-inner' style={{border:"none"}}>                    
                    <div className='login-content'> 
                        {errMsg.cls? <div className={errMsg.cls}>{errMsg.msg}</div>:'' }
                        <Form noValidate validated={validated} onSubmit={handleSubmit} className={`reset-form${formHide}`}>            
                            <div className='login-data'>Change your password, this helps to keep your new password secure.</div>                      
                            <div className='login-data'><input type="password" minLength={8} placeholder="New Password" name='new_password' className='form-control input-text' value={password} onChange={(e)=>{ setPassword(e.target.value); }} required />
                            <div className="password-strength">
                              <PasswordStrengthBar password={password} minLength={8} shortScoreWord={'Hint: The password should be at least 8 characters long. To make it stronger, use upper and lower case letters, numbers, and symbols like ! " ? $ % ^ & ).'} scoreWords={['Hint: The password should be at least 8 characters long. To make it stronger, use upper and lower case letters, numbers, and symbols like ! " ? $ % ^ & ).', 'Hint: The password should be at least 8 characters long. To make it stronger, use upper and lower case letters, numbers, and symbols like ! " ? $ % ^ & ).', 'Hint: The password should be at least 8 characters long. To make it stronger, use upper and lower case letters, numbers, and symbols like ! " ? $ % ^ & ).', 'Hint: The password should be at least 8 characters long. To make it stronger, use upper and lower case letters, numbers, and symbols like ! " ? $ % ^ & ).','Hint: The password should be at least 8 characters long. To make it stronger, use upper and lower case letters, numbers, and symbols like ! " ? $ % ^ & ).']}/>
                            </div>
                            </div>
                            <div className='login-data'>                                                
                            <input type="password" name='confirm_password' placeholder="Confirm Password" minLength={8} className={`form-control input-text${passwordMatch}`}  value={cnfpassword} onChange={(e)=>{setCnfpassword(e.target.value);}} required />
                            </div> 

                        <div className='login-data'><button type="submit" className="btn" disabled={loading?true:false}>{loading?'Loading...':'Reset password'}</button></div> 
                        </Form> 
                        {sent?( <div className='login-data redirecting-now'>
                        <div className='redirecting-text'>Redirecting now... <Spinner animation="border" /></div>
                      </div>):''}
                        
                      {!validToken?(
                        <div className="alert alert-warning text-center" style={{marginBottom:"0"}}>This key is invalid or has already been used. Please <Link to={'/loginwithemail'}>login</Link> or <Link to={'/recoverpassword'}>reset</Link> your password again if needed.</div>
                        ):''}
                    </div>
                </div>
            </div>
        </div>
    </Layout>
  )
}

export default ResetPassword
